import React from 'react';
import { Check } from 'lucide-react';

export default function ValidationProofSection({ stats }) {
  return (
    <section className="py-24 md:py-32 px-4 sm:px-6 lg:px-8 bg-[#0A0A0A]">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl sm:text-4xl font-bold text-center text-white mb-12 tracking-tight" style={{ fontFamily: "'Outfit', sans-serif" }}>
          Proven with Real-World Data
        </h2>

        <div className="grid md:grid-cols-2 gap-8">
          {/* Left: Stats */}
          <div className="space-y-4" data-testid="landing-proven-stats">
            <div className="flex items-start gap-3">
              <Check className="w-6 h-6 text-[#00D26A] flex-shrink-0 mt-1" />
              <p className="text-lg text-white">
                <span data-testid="stat-validated-barcodes">{stats?.validated_barcodes ?? '73'}</span> real barcodes tested
              </p>
            </div>
            <div className="flex items-start gap-3">
              <Check className="w-6 h-6 text-[#00D26A] flex-shrink-0 mt-1" />
              <p className="text-lg text-white">
                <span data-testid="stat-roi">{stats?.roi_pct ?? 447}%</span> proven beta-tester ROI (charity-shop sourcing)
              </p>
            </div>
            <div className="flex items-start gap-3">
              <Check className="w-6 h-6 text-[#00D26A] flex-shrink-0 mt-1" />
              <p className="text-lg text-white">
                <span data-testid="stat-portfolio-lift">+{stats?.portfolio_lift_pct ?? 107}%</span> avg profit vs single-buyer scanning
              </p>
            </div>
            <div className="flex items-start gap-3">
              <Check className="w-6 h-6 text-[#00D26A] flex-shrink-0 mt-1" />
              <p className="text-lg text-white">Works on books, DVDs, CDs, and games</p>
            </div>
          </div>

          {/* Right: Two worked examples */}
          <div className="space-y-6">
            <div className="bg-[#050505] border border-zinc-800/50 p-6 rounded-2xl text-white shadow-lg" data-testid="validation-example-a">
              <h3 className="text-lg font-bold mb-3">Example A — Blu-ray (low-value arbitrage)</h3>
              <div className="space-y-2 font-mono text-sm">
                <p className="border-b border-zinc-800 pb-2 text-zinc-500 text-xs">Barcode: 5051561002281</p>
                <p className="text-red-500 font-semibold">Buyer A: £0.67</p>
                <p className="text-red-500 font-semibold">Buyer B: £0.10</p>
                <p className="text-red-500 font-semibold">Buyer C: REJECTED (£0.00)</p>
                <p className="text-[#FFD700] font-bold text-base">Buyer D voucher: £1.90 ← Best offer</p>
                <p className="border-t border-zinc-800 pt-2 text-[#FFD700] font-bold text-xs">
                  +£1.23 uplift (184% more than Buyer A)
                </p>
              </div>
            </div>

            <div className="bg-[#050505] border border-[#FFD700]/40 p-6 rounded-2xl text-white shadow-[0_0_30px_rgba(255,215,0,0.08)]" data-testid="validation-example-b">
              <h3 className="text-lg font-bold mb-3">Example B — CBBC DVD (high-value outlier)</h3>
              <div className="space-y-2 font-mono text-sm">
                <p className="text-red-500 font-semibold">Buyer A: £0.20</p>
                <p className="text-[#00D26A] font-semibold">Buyer B: £2.00</p>
                <p className="text-[#00D26A] font-semibold">Buyer C: £2.80</p>
                <p className="text-[#00D26A] font-semibold">Buyer D cash: £7.00</p>
                <p className="text-[#FFD700] font-bold text-base">Buyer D voucher: £10.00 ← Best offer</p>
                <p className="border-t border-zinc-800 pt-2 text-[#FFD700] font-bold text-xs">
                  +£9.80 uplift vs Buyer A · voucher re-spends at ~1.12× cash via our arbitrage cycle
                </p>
              </div>
            </div>

            <p className="text-zinc-400 text-xs leading-relaxed">
              Without Flipping Friends, most resellers default to the first buyer they check. With all 4 compared side-by-side, the winner is almost always somewhere else — and sometimes the voucher offer, re-spent via our arbitrage cycle, is the crown.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
